import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import Sorting from './sorting';

export default function CompSelectorHeader({ query, sort, type, onQueryChange, onSortChange }) {
  return (
    <div className="d-flex align-items-center gap-3 mb-3">
      <ManagedInput
        className="flex-fill form-control"
        icon
        name="searchTextCont"
        placeholder="Search comps by name, address, city, or zip"
        value={query.searchTextCont || ''}
        onChange={onQueryChange}
      />

      <Sorting
        sort={sort}
        type={type}
        onChange={onSortChange}
      />
    </div>
  );
}

CompSelectorHeader.propTypes = {
  query: PropTypes.shape({
    searchTextCont: PropTypes.string,
  }).isRequired,
  sort: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
};
